/* =========================================================================
 * Kkumi · Wishlist Hero chip counts
 * Fills the hero stat chips with live counts from the wishlist grid (via
 * KkwlBus). Chips opt in with data-kkwl-count-source = saved|sale|oos.
 * Sale/out-of-stock chips hide when their count is zero.
 * ========================================================================= */
(function () {
  'use strict';

  var heroes = document.querySelectorAll('[data-kkwl-hero]');
  if (!heroes.length) return;

  if (!window.KkwlBus) { return; }

  var esc = window.KKEsc; // canonical shared escaper (assets/kkumi-esc.js)

  /* ---- Shared (read-only) view: rewrite the hero copy for someone else's list ---- */
  if (window.KkwlBus.sharedId) {
    var sharedBy = (function () { try { return new URLSearchParams(window.location.search).get('by') || ''; } catch (e) { return ''; } })();
    var reveal = function (hero) {
      ['.kkwl-hero__eyebrow', '.kkwl-hero__title', '.kkwl-hero__sub'].forEach(function (sel) {
        var el = hero.querySelector(sel); if (el) el.style.visibility = 'visible';
      });
    };
    var applyShared = function (rawName) {
      Array.prototype.forEach.call(heroes, function (hero) {
        var fallback = hero.getAttribute('data-kkwl-shared-fallback') || 'a friend';
        var name = esc(rawName || fallback);
        // Richtext fields encode { } as &lcub; &rcub;, so match both forms.
        var fill = function (tpl) { return (tpl || '').split('&lcub;name&rcub;').join(name).split('{name}').join(name); };
        var ebTpl = hero.getAttribute('data-kkwl-shared-eyebrow');
        var hTpl = hero.getAttribute('data-kkwl-shared-heading');
        var sTpl = hero.getAttribute('data-kkwl-shared-sub');
        var eb = hero.querySelector('.kkwl-hero__eyebrow');
        var title = hero.querySelector('.kkwl-hero__title');
        var sub = hero.querySelector('.kkwl-hero__sub');
        // Use the shared template when set, else fall back to the existing copy —
        // and always run fill() over the result so no literal {name} can survive.
        if (eb) eb.innerHTML = '<span class="kkwl-hero__rule" aria-hidden="true"></span>' + fill(esc(ebTpl) || eb.textContent.trim());
        if (title) title.innerHTML = fill(hTpl || title.innerHTML);
        if (sub) sub.innerHTML = fill(sTpl || sub.innerHTML);
        reveal(hero);
      });
    };
    // Use the name from the link straight away (no "your wishlist" / "a friend" flash);
    // the bus refines it only if a real name arrives later.
    applyShared(sharedBy);
    window.KkwlBus.on('shared', function (d) { if (d && d.name) { applyShared(d.name); } });
    setTimeout(function () { Array.prototype.forEach.call(heroes, reveal); }, 1500); // failsafe reveal
  }

  function update(state) {
    if (!state) return;
    Array.prototype.forEach.call(heroes, function (hero) {
      Array.prototype.forEach.call(hero.querySelectorAll('[data-kkwl-count-source]'), function (chip) {
        var src = chip.getAttribute('data-kkwl-count-source');
        var n;
        if (src === 'saved') n = state.total;
        else if (src === 'sale') n = state.sale;
        else if (src === 'oos') n = state.outStock;
        else return; // 'none' — leave the merchant's number alone
        var numEl = chip.querySelector('.kkwl-hero__chip-num');
        if (numEl) { numEl.textContent = (n == null ? 0 : n); numEl.style.visibility = 'visible'; }
        // Hide sale / out-of-stock chips when there's nothing to report.
        if (src === 'sale' || src === 'oos') chip.hidden = !n;
      });
    });
  }

  window.KkwlBus.on('change', update);
})();
